/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

/**
 * How a set of students was selected: exactly one mode drives the selection, the other criteria stay empty. Deliberately general and value-identical to `Catwise\Portfolio\Enums\PortfolioTaskStudentSource`, so Portfolio can fold into this one later without a data migration. Until that refactor lands, both exist; new code uses this one.
 */
export type StudentSource = typeof StudentSource[keyof typeof StudentSource];


export const StudentSource = {
  education_levels: 'education_levels',
  mentor_classes: 'mentor_classes',
  lesson_groups: 'lesson_groups',
  student_ids: 'student_ids',
} as const;
